import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Modal from 'components/UI/Modal/Modal';
import LoginForm from "screens/Auth/LoginForm/LoginForm";
import RegisterForm from "screens/Auth/RegisterForm/RegisterForm";
import FillForm from "screens/Auth/FillForm/FillForm.js";
import AcceptForm from "screens/Auth/AcceptForm/AcceptForm"
import { verifyFields, handleActionNext, handleActionBack, clearStorage, handlePwMsg } from 'helpers/AuthHelper';
import { checkAndConvertMetadata, checkAndClearInputs } from "helpers/MetadataHelper";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ConfigTypes from 'config/ConfigTypes';
import Spinner from 'layouts/UIElements/Spinner/Spinner';
import { getDialogConfig } from "helpers/ConfigHelper";
import { showConfirmMsgDlg } from 'helpers/AppHelper';

import './Authentication.scss'

const Authentication = observer(
    class Authentication extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                modalOpened: false,
                showAuth: false,
                formErrors: {},
                loading: false,
            }
        }

        initData = () => {
            this.props.getInsts();
        }

        checkAuth = () => {
            //const token = getAuthToken();
            const token = localStorage.getItem('token');
            if (token) {
                const storedDate = localStorage.getItem('expiration');
                const expirationDate = new Date(storedDate);
                const now = new Date();
                if ((expirationDate.getTime() - now.getTime()) < 0) {
                    clearStorage();
                    this.props.setInitialState({})
                    this.props.updateAuthObjects({ isLoggedIn: false });
                } else {
                    this.props.updateAuthObjects({ isLoggedIn: true });
                }
            } else {
                this.props.updateAuthObjects({ isLoggedIn: false });
            }
        }

        updateData = (prevProps, prevState) => {
            const { showAuth, isLoggedIn, loginErr, status } = this.props.authObjects;
            if (prevProps.authObjects.showAuth != showAuth) {
                //this.setState({ modalOpened: true, showAuth: showAuth });
                this.setState({ modalOpened: showAuth, showAuth: showAuth });
            }
            if (!prevProps.authObjects.isLoggedIn && isLoggedIn) {
                this.loginSuccess();
            }
            if (!prevProps.authObjects.loginErr && loginErr) {
                this.setState({ loginErr: loginErr });
            }

            if (this.props.authObjects.authForm
                && this.props.authObjects.authForm == ConfigTypes.FILL_USER
                && !prevProps.authObjects.shouldUpdate && this.props.authObjects.shouldUpdate
            ) {
                this.setState({ authForm: ConfigTypes.FILL_USER });
                this.props.updateAuthObjects({ shouldUpdate: false });
            }
            if (status && prevProps.authObjects.status !== status) {
                if (status && status.msg) this.showMsg({ msg: status.msg });
            }
        }

        formatMessage = ({ id }) => this.props.intl.formatMessage({ id });

        showMsg = ({ msg }) => {
            let htmlMsg = handlePwMsg({ msg, formatMessage: this.formatMessage });
            showConfirmMsgDlg({
                htmlMsg, formatMessage: this.formatMessage, cb: () => { }
            });
        }

        loginSuccess = () => {
            const { user } = this.props.authObjects;
            if (user) {
                this.setState({ modalOpened: false, showAuth: false, loginErr: false });
                localStorage.setItem('token', 'tokenabc');
                const expiration = new Date();
                expiration.setHours(expiration.getHours() + ConfigTypes.AUTH_EXPIRATION);
                localStorage.setItem('expiration', expiration.toISOString());
                this.props.updateAuthObjects({ isLoggedIn: true, [this.state.authForm]: user, showAuth: false });
            }
        }

        handleLoginSubmit = (userInputs) => {
            const { authForm } = this.props.authObjects;
            this.setState({ loginErr: false, formErrors: {} });
            const res = verifyFields({ userInputs, authForm, configObjects: this.props.configObjects });
            if (res) {
                if (res.noErrors) {
                    this.props.loginFeUser(userInputs);
                } else {
                    this.setState({
                        formErrors: { [this.state.authForm]: { ...res } },
                        [this.state.authForm]: userInputs
                    });
                }
            }
        }

        checkEmail = async ({ userInputs }) => {
            let emailError = null;
            let checkFields = getDialogConfig({
                dialogMode: ConfigTypes.REGISTER_CHECK,
                configObjects: this.props.configObjects, configName: "userconfig"
            });
            let obj = checkFields.find(item => item.type === ConfigTypes.EMAIL);
            if (obj) {
                let uEmail = userInputs[obj.field];
                if (uEmail) {
                    console.log("LOGS: checkEmail uEmail", uEmail);
                    const res = await window.flow.sdkFeReCheckUser({ [`${obj.field}`]: uEmail });
                    console.log("LOGS: checkEmail res", res);
                    if (res && !res.success) {
                        emailError = { [`${obj.field}`]: this.formatMessage({ id: `data.auth.${res.msg}` }) };
                    }
                }
            }
            return emailError;
        }

        checkInst = async ({ isOk, userInputs, authForm, action }) => {
            if (action && action === ConfigTypes.NEXT
                && authForm === ConfigTypes.REGISTER_CREATE_INST) {
                console.log("LOGs: sdkFeReAddInst inst", userInputs);
                const res = await window.flow.sdkFeReAddInst({ ...userInputs });
                console.log("LOGs: dkFeReAddInst RES", res);
                if (res) {
                    if (!res.success) isOk = false;
                    if (res && res.data) return { ...res.data };
                }
            }
            return isOk;
        }

        handleAuthSubmit = async ({ userInputs, nextForm = null, action }) => {
            const { authForm } = this.props.authObjects;
            const res = verifyFields({ userInputs, authForm, configObjects: this.props.configObjects });
            const emailError = await this.checkEmail({ userInputs });
            let isOk = true;
            if (res) {
                if (res.noErrors && !emailError) {
                    isOk = await this.checkInst({ isOk, userInputs, authForm, action });
                    if (isOk && isOk.instid) userInputs = { ...userInputs, [ConfigTypes.USER_INST]: isOk.instid }
                    this.props.updateAuthObjects({ [this.state.authForm]: userInputs });
                    if (nextForm && isOk) {
                        let changed = checkAndConvertMetadata({ userInputs });
                        if (changed) this.props.updateAuthObjects({ [authForm]: changed });
                        if (authForm && authForm === ConfigTypes.REGISTER_CREATE_INST) {
                            if (this.props.authObjects[ConfigTypes.REGISTER_INST]) {
                                this.props.updateAuthObjects({ [ConfigTypes.REGISTER_INST]: null });
                            }
                        }
                        this.handleFormClick({ authForm: nextForm, prevForm: authForm })();
                    }
                    if (action && action === ConfigTypes.REGISTER_APPLY) {
                        let nUserInputs = checkAndClearInputs({ userInputs, configObjects: this.props.configObjects });
                        this.props.addUser(nUserInputs);
                    }
                } else {
                    let errors = { ...res };
                    if (emailError) errors = { ...errors, ...emailError };
                    this.setState({
                        formErrors: { [this.state.authForm]: errors },
                        [this.state.authForm]: userInputs
                    });
                }
            }
        }

        handleFormClick = ({ authForm, prevForm = null, action = null }) => () => {
            this.setState({ authForm: authForm });
            let updatedObj = { showAuth: authForm, authForm };
            if (action && action === ConfigTypes.BACK) updatedObj[prevForm] = null;
            if (prevForm && prevForm !== ConfigTypes.REGISTER_OVERVIEW) {
                updatedObj.prevAuthForm = prevForm;
            }
            this.props.updateAuthObjects(updatedObj);
        }

        handleBtnClick = ({ authForm }) => {
            this.handleFormClick({ authForm: authForm })();
        }

        handleFillSave = ({ userInputs, authForm }) => {
            if (authForm === ConfigTypes.FILL_USER) {
                const res = verifyFields({ userInputs, authForm, configInputs: this.props.authObjects.fillData });
                this.props.saveFillData({ userInputs })
                if (res) {
                    if (res.noErrors) {
                        this.props.saveFillData({ userInputs })
                    } else {
                        let errors = { ...res };
                        this.setState({
                            formErrors: { [this.state.authForm]: errors },
                            [this.state.authForm]: userInputs
                        });
                    }
                }
            }
        }

        handleAction = ({ action, userInputs }) => {
            const { prevAuthForm, authForm } = this.props.authObjects;
            switch (action) {
                case ConfigTypes.NEXT:
                case ConfigTypes.REGISTER_APPLY:
                    let nextForm = handleActionNext({
                        authForm, authObjects: this.props.authObjects,
                        configObjects: this.props.configObjects
                    });
                    this.handleAuthSubmit({ userInputs, nextForm, action });
                    break;
                case ConfigTypes.BACK:
                    if (authForm === ConfigTypes.REGISTER_NEW_INST) {
                        this.props.updateAuthObjects({ [authForm]: null });
                    }
                    let backAuthForm = handleActionBack({ authForm, prevAuthForm });
                    if (backAuthForm) {
                        this.handleFormClick({ authForm: backAuthForm, prevForm: authForm, action })();
                        this.setState({ formErrors: {} });
                    }
                    break;
                case ConfigTypes.FILL_SAVE:
                    this.handleFillSave({ userInputs, authForm });
                    break;
                case ConfigTypes.FILL_CANCEL:
                    this.props.updateAuthObjects({ authForm: ConfigTypes.LOGIN, loading: false });
                    this.setState({ authForm: ConfigTypes.LOGIN });
                    break;
                default:
                    break;
            }
        }


        closeModal = () => {
            this.setState({ modalOpened: false, authForm: ConfigTypes.LOGIN });
            this.props.setInitialState({});
        }

        showForm = () => {
            switch (this.state.authForm) {
                case ConfigTypes.ACCEPT:
                    return (
                        <AcceptForm formatMessage={this.props.intl.formatMessage}
                            setInitData={this.props.setInitialState} updateAuthObjects={this.props.updateAuthObjects}
                            onInsitution={this.handleFormClick({ authForm: ConfigTypes.REGISTER_INST, prevForm: ConfigTypes.ACCEPT })}
                            onUser={this.handleFormClick({ authForm: ConfigTypes.REGISTER_USER, prevForm: ConfigTypes.ACCEPT })} />
                    );
                case ConfigTypes.LOGIN:
                    return <LoginForm onSubmitClick={this.handleLoginSubmit}
                        formatMessage={this.props.intl.formatMessage} loading={this.props.loading}
                        errors={this.state.formErrors[this.state.authForm] || {}} loginErr={this.state.loginErr}
                        onRegisterClick={this.handleFormClick({ authForm: ConfigTypes.ACCEPT })}
                        reqForgotPw={this.props.reqForgotPw} />
                case ConfigTypes.FILL_USER:
                    return <FillForm authForm={this.state.authForm} onSubmitClick={this.handleAuthSubmit}
                        errors={this.state.formErrors[this.state.authForm] || {}}
                        formatMessage={this.props.intl.formatMessage} onBtnClick={this.handleBtnClick}
                        onActionClick={this.handleAction} configObjects={this.props.configObjects}
                        authObjects={this.props.authObjects} updateAuthObjects={this.props.updateAuthObjects}
                        onLoginClick={this.handleFormClick({ authForm: ConfigTypes.LOGIN })} />
                default:
                    return <RegisterForm authForm={this.state.authForm} onSubmitClick={this.handleAuthSubmit}
                        errors={this.state.formErrors[this.state.authForm] || {}}
                        formatMessage={this.props.intl.formatMessage} onBtnClick={this.handleBtnClick}
                        onActionClick={this.handleAction} configObjects={this.props.configObjects}
                        authObjects={this.props.authObjects} updateAuthObjects={this.props.updateAuthObjects}
                        onLoginClick={this.handleFormClick({ authForm: ConfigTypes.LOGIN })}
                        getInsts={this.props.getInsts}
                    />
            }
        }


        componentDidUpdate(prev, prevState) {
            this.updateData(prev, prevState);
        }

        componentDidMount() {
            const { authForm } = this.props.authObjects;
            this.setState({ authForm: authForm });
            this.checkAuth()
        }

        render() {
            return (
                <div className="Authentication">
                    <Modal className="authentication-modal" open={this.state.modalOpened}
                        onClose={() => this.setState({ modalOpened: false })}>
                        <div className="authentication-close" onClick={this.closeModal}>
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                        {this.state.showAuth && this.showForm()}
                    </Modal>
                    {this.state.loading && (
                        <div className="authentication-overlay">
                            <Spinner />
                        </div>)}
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    authObjects: state.auth.authObjects,
    configObjects: state.config.configObjects,
    loading: state.auth.authObjects.loading
});

const mapDispatchToProps = (dispatch) => ({
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
    setInitialState: (data) => dispatch(actions.setInitialState(data)),
    loginFeUser: (data) => dispatch(actions.loginFeUser(data)),
    getInsts: () => dispatch(actions.getInsts()),
    addUser: (userInputs) => dispatch(actions.addUser(userInputs)),
    saveFillData: (userInputs) => dispatch(actions.saveFillData(userInputs)),
    reqForgotPw: (obj) => dispatch(actions.reqForgotPw(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(Authentication))));


